import { SVGProps } from 'react'

export const ChangelogIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.83335 7.16675H14.1667M5.83335 10.5001H10.8334M5.83335 13.8334H12.5M10 18.8334V18.8334C12.1712 18.8334 13.2568 18.8334 14.1376 18.5557C16.0046 17.9671 17.467 16.5046 18.0557 14.6376C18.3334 13.7569 18.3334 12.6713 18.3334 10.5001V10.5001C18.3334 8.32887 18.3334 7.24326 18.0557 6.36251C17.467 4.49553 16.0046 3.0331 14.1376 2.44445C13.2568 2.16675 12.1712 2.16675 10 2.16675V2.16675C7.82881 2.16675 6.7432 2.16675 5.86245 2.44445C3.99547 3.0331 2.53304 4.49553 1.94439 6.36251C1.66669 7.24326 1.66669 8.32887 1.66669 10.5001V10.5001C1.66669 12.6713 1.66669 13.7569 1.94439 14.6376C2.53304 16.5046 3.99547 17.9671 5.86245 18.5557C6.7432 18.8334 7.82881 18.8334 10 18.8334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
